import { Translations } from '@scorenco/components';

export const T_KEYS = {
  ...Translations.T_KEYS,

  // COMMON
  SCORENCO_FOOTER: 'SCORENCO_FOOTER',

  // WEEK-EVENTS
  PREVIOUS: 'PREVIOUS',
  CURRENT: 'CURRENT',
  NEXT: 'NEXT',
  PREVIOUS_EVENT: 'PREVIOUS_EVENT',
  NEXT_EVENT: 'NEXT_EVENT',
  DATE_FNS_LOCALE: 'DATE_FNS_LOCALE',
  DATE_FNS_FORMAT: 'DATE_FNS_FORMAT',

  // LIVE
  SPONSORS_LIVE_OFFERED_BY: 'SPONSORS_LIVE_OFFERED_BY',
  EVENT_INFO_SLIDE_DATE_FORMAT: 'EVENT_INFO_SLIDE_DATE_FORMAT',
  LIVE_SHOW_NEXT: 'LIVE_SHOW_NEXT',
  EVENT_TO_COME: 'EVENT_TO_COME',
  EVENT_POSTPONED: 'EVENT_POSTPONED',
  EVENT_WITHDRAWAL: 'EVENT_WITHDRAWAL',
  EVENT_LIVE: 'EVENT_LIVE',
  EVENT_FINISH: 'EVENT_FINISH',

  WIDGET_ERROR: 'WIDGET_ERROR',
  EVENT_INFORMATIONS: 'EVENT_INFORMATIONS',
  LIVE_WITH: 'LIVE_WITH',
  HMMM_EMPTY: 'HMMM_EMPTY',
  NO_COMMENTS_EVENT: 'NO_COMMENTS_EVENT',

  TEAMS_PLAYERS_STAFF: 'TEAMS_PLAYERS_STAFF',
  TEAMS_PLAYERS_STAFF_NOBODY: 'TEAMS_PLAYERS_STAFF_NOBODY',
  TEAMS_PLAYERS_PLAYERS: 'TEAMS_PLAYERS_PLAYERS',
  TEAMS_PLAYERS_PLAYERS_NOBODY: 'TEAMS_PLAYERS_PLAYERS_NOBODY',
};

export type T_KEYS = typeof T_KEYS;
